import { gql } from "@apollo/client"


export const GET_HAL_BRANCHS = gql`
query GetHalBranchList($where: ShopAddressWhereInput) {
    getHalBranchList(where: $where) {
      provinces {
        id
        name
      }
      districts {
        id
        name
        province_id
      }
      villages {
        id
        name
        district_id
      }
      branchDatas
    }
  }
`

export const GET_MIXAY_PROVINCES = gql`
query Provinces($where: ShopAddressWhereInput) {
  getMixayProvinces(where: $where) {
    provinces {
      id
      name
    }
  }
}
`
export const GET_MIXAY_PROVINCES_V2 = gql`
  query GetMixayProvincesV2 {
    getMixayProvincesV2 {
      provinces {
        id
        name
      }
    }
  }
`;

export const GET_JNT_PROVINCES = gql`
  query GetJntProvinces {
    getJntProvinces {
      provinces {
        id
        name
      }
      districts {
        id
        name
        province_id
      }
      branchDatas
    }
  }
`;

export const GET_MIXAY_DROPSHIPS = gql`
query GetMixayDropships($where: ShopAddressWhereInput) {
  getMixayDropships(where: $where) {
    branchDatas 
  }
}
`
export const GET_MIXAY_DROP_SHIPS_V2 = gql`
  query GetMixayDropShipsV2($where: ShopAddressWhereInput) {
    getMixayDropShipsV2(where: $where) {
      branchDatas
    }
  }
`;

export const GET_MIXAY_DEFAULT_DSE = gql`
  query Query($where: ShopAddressWhereInput) {
    getMixayDefaultDSE(where: $where)
  }
`;

export const GET_SHOP_ADDRESS_DEFAULT = gql`
query Data($where: ShopAddressWhereInput) {
    shopAddressShopId(where: $where) {
      data {
        id
        shop
        fullName
        shopName
        deliveryName
        shopTel
        province
        district
        village
        branch
        branchCode
        isOpen
        address
        sender_branch_id
        setDefault
        createdAt
        codNumber
        updatedAt
        postcode
        dropship_end
      }
      total
    }
  }
`